export default __webpack_public_path__ + "static/media/cover.29b0af2d.jpeg";